import apiService from "./ApiService"
import { createQS } from "./Utils"

class ProjetoService {

  async get(termo, idContrato, pagina) {
    try {
      const qs = createQS({ termo, idContrato, pagina })
      return await apiService.get('projeto?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('projeto/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('projeto', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async update(id, data) {
    try {
      return await apiService.put('projeto/' + id, data)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }  
}

const projetoService = new ProjetoService()
export default projetoService